<template>
  <div>
    <BigHeader  title="Contact Us" subtitle="" icon1="" line1="" icon2=""  line2="" icon3=""  line3=""></BigHeader>

    <v-container flex grid-list-xl  class="pb-0">

      <v-layout
        text-xs-center
        wrap
      >

        <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3">

          <v-layout
            text-xs-left
            wrap
          >

            <v-flex xs12>

              <v-layout
                text-xs-left
                wrap
              >

                <v-flex id="lisa" xs12 md8>
                  <div class="title ml-3 mb-3">Send us an email</div>
                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     " class="elevation-0">
                    <v-card-text>

                      <v-form>
                        <v-autocomplete
                          v-model="selected"
                          :items="['Trevor Handsen', 'Alex Nelson']"
                          chips
                          label="To"
                          full-width
                          hide-details
                          hide-no-data
                          hide-selected
                          multiple
                          single-line
                        ></v-autocomplete>
                        <v-divider></v-divider>
                        <v-text-field
                          label="Subject"
                          value="Plans for the weekend"
                          single-line
                          full-width
                          hide-details
                        ></v-text-field>
                        <v-divider></v-divider>
                        <v-textarea
                          height="240"
                          v-model="title"
                          label="Message"
                          counter
                          maxlength="1000"
                          full-width
                          single-line
                        ></v-textarea>
                      </v-form>

                    </v-card-text>
                  </v-card>

                </v-flex>
                <v-flex xs12 md4>

                  <div class="title ml-3 mb-3">Call us</div>

                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     height: calc(100% - 32px);" class="elevation-0">

                    <v-timeline
                      align-top
                      dense
                    >
                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>LISA Press Office</strong>
                            <div class="caption">+1 123 456789</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Rent a scientist</strong>
                            <div class="caption">+1 123 456789</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>LISA Mission Office</strong>
                            <div class="caption">+1 123 456789</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>ESA</strong>
                            <div class="caption">+1 123 456789</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>NASA</strong>
                            <div class="caption">+1 123 456789</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                    </v-timeline>


                  </v-card>

                </v-flex>

              </v-layout>

            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>

    </v-container>

<div style="height:600px;"></div>
  </div>
</template>

<script>

  import BigHeader from '../components/BigHeader'

  export default {
    components: {
      BigHeader
    },
    data () {
      return {
        selected: ['Trevor Handsen'],
        items: ['Trevor Handsen', 'Alex Nelson'],
        title: 'Hi,\nI just wanted to check in and see if you had any plans the upcoming weekend. We are thinking of heading up to Napa'

      }
    }
  }
</script>
